import { getDateTime } from "../../services/CheckMeProBlePackages";
import { ECGInnerItem    } from "./ECGInnerItem";
export interface TemperatureItem{

    date: Date
    way: number
    tmp: number
  
    face:number
   
   
}


    const PACKAGESIZE =10;

    export function parseTemperatureItem (bytes: number[]  ) : TemperatureItem[]{
        
        let start = 0
    
        const returnList:  TemperatureItem[] = new Array();
        for (let k = 0; k < bytes.length -8; k++) {
            if ( start +PACKAGESIZE >= bytes.length  )
                break;
            const user = {} as TemperatureItem
            returnList.push(user)

            start = k * PACKAGESIZE
            user.date = getDateTime(bytes,start)
            user.way = bytes[start + 7]
            
            user.tmp =  (bytes[start + 9] & 0xff) + ((bytes[start + 9] & 0xff) << 8); 

        

        }

        return returnList;

    }